import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TruckType } from 'src/typings/route';
import { Route } from '../../sl-data/route';
import { BehaviorSubject } from 'rxjs';
import { UtilitiesService } from 'src/app/services/utilities.service';


@Component({
    selector: 'app-edit-truck-type',
    templateUrl: './edit-truck-type.component.html',
    styleUrls: ['./edit-truck-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditTruckTypeComponent {
    @Input() currentTruckType: TruckType = null;
    @Input() route: Route = null;
    @Input() dismissFn: () => void;
    public saving$ = new BehaviorSubject(false);

    public selectedType: TruckType;

    public truckTypes: { value: TruckType; label: string }[] = [
        { value: 'rigid_truck',    label: 'Rigid Truck' },
        { value: 'semi_trailer',   label: 'Semi Trailer' },
        { value: 'b_double',       label: 'B-Double' },
        { value: 'road_train',     label: 'Road Train' },
        { value: 'not_a_truck',  label: 'Not a truck' },
        { value: 'generic_truck',  label: 'Generic Truck' },
    ];

    constructor(
        private utilities:UtilitiesService,
    ) { }

    ngOnInit() {
        this.selectedType = this.currentTruckType;
    }

    public select(value: TruckType) {
        this.selectedType = value;
    }

    public async okayHandler() {
        try{
            this.saving$.next(true);
            await this.route.setTruckType(this.selectedType);
            this.utilities.notifySuccess('Job time window updated successfully.');
        }
        catch(err){
            console.log(err);            
            this.utilities.notifyError('Unexpected error updating job time window. Please contact system admin');
        }
        finally{
            this.saving$.next(false);
            this.dismissFn();
        }
    }

    public cancelHandler() {
        this.dismissFn();
    }
}
